import React from 'react';
import { type CommissioningStepName, HumanReadableCommissioningStep } from '../stages';
import { SelectableFilters, truncateAppliedFilters } from './SelectableFilters';
import { FilterComponentProps } from './types';

type CommissioningStepFilterValues = Record<CommissioningStepName, boolean>;

const defaultFilters: CommissioningStepFilterValues = {
  wifi: false,
  updateFirmware: false,
  supplyMonitoring: false,
  chargerSetup: false,
  installationRecord: false,
  installationPhotos: false,
  applyConfiguration: false,
  currentTransformerChecks: false,
};

function renderValues(value: [string, boolean][]): string {
  return truncateAppliedFilters(
    value.flatMap(([filterKey, filterApplied]) =>
      filterApplied ? [HumanReadableCommissioningStep[filterKey as CommissioningStepName]] : [],
    ),
  );
}

export const CommissioningStepFilters: React.FC<FilterComponentProps> = ({ columnDef, onFilterChanged }) => (
  <SelectableFilters<CommissioningStepName, CommissioningStepFilterValues>
    columnDef={columnDef}
    defaultFilters={defaultFilters}
    onFilterChanged={onFilterChanged}
    options={Object.entries(HumanReadableCommissioningStep)}
    renderValues={renderValues}
  />
);
